// extracted by mini-css-extract-plugin
export default {"container":"DynamicLegendButton_container__H6Gd0","active":"DynamicLegendButton_active__WxbPD"};